import {
  CheckCircle,
  XCircle,
  Warning,
  Info,
  SpinnerGap,
} from '@phosphor-icons/react';
import { Toast } from 'react-hot-toast';
import { cn } from './tailwindmerge';

type ToastType = 'success' | 'error' | 'warning' | 'info' | 'loading';

interface CustomToastProps {
  t: Toast;
  type: ToastType;
  message: string;
  testId?: string;
}

const iconMap = {
  success: <CheckCircle size={24} weight="bold" className="" />,
  error: <XCircle size={24} weight="bold" className="" />,
  warning: <Warning size={24} weight="bold" className="" />,
  info: <Info size={24} weight="bold" className="" />,
  loading: (
    <SpinnerGap
      size={24}
      weight="bold"
      className="animate-spin text-gray-600"
    />
  ),
};

const CustomToast = ({ t, type, message, testId }: CustomToastProps) => {
  return (
    <div
      data-testid={`toast-${testId}`}
      className={cn(
        'flex w-80 items-center gap-3 rounded-lg px-4 py-3 text-white shadow-md transition-all duration-300',
        {
          'bg-brandSuccess-600': type === 'success',
          'bg-brandRed-500': type === 'error',
          'bg-brandWarning-600': type === 'warning',
          'bg-primary-600': type === 'info',
          'bg-brandWarning-400': type === 'loading',
        },
        t.visible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
      )}
    >
      {iconMap[type]}
      <span className="font-medium">{message}</span>
    </div>
  );
};

export default CustomToast;
